import { Box, Skeleton, Typography } from "@avenue-8/sidekick-ui";
import { textFormatter } from "@shared/utils/text-formatter";

type Props = {
  meta: {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
  } | null;
  isLoading?: boolean;
};

export const ResultsSummary = ({ meta, isLoading }: Props) => {
  if (isLoading) {
    return (
      <Box height={24}>
        <Skeleton width={160} variant="text" height={16} />
      </Box>
    );
  }

  const content = !meta?.totalItems
    ? "No results"
    : meta.totalItems === 1
      ? "1 result"
      : `${textFormatter.number(meta.totalItems)} results`;

  return (
    <Box display={"flex"} alignItems={"center"} height={24}>
      <Typography variant="body2" textAlign="center" fontWeight={700}>
        {content}
      </Typography>
    </Box>
  );
};
